<template>
  <div id="app">
    <vue-typed-js :strings="strings" :typeSpeed="100" :startDelay="1000">
      <span class="typing"></span>
    </vue-typed-js>
  </div>
</template>

<script>
/* global twemoji */

import { Component, Vue } from "vue-property-decorator"

export default
@Component
class App extends Vue {
  // noinspection JSMethodCanBeStatic
  get strings() {
    const s1 = "<span class='heading'>HINWEIS</span>^3000\n^500\n^500" + "Dies ist keine Homepage.^2000"
    const s2 = s1 + "\n^500\n^500<b class='warning'>Bitte verlassen Sie umgehend diese Seite!</b>^3000"
    const s3 =
      "<span class='heading'>WARNUNG</span>^1000\n^500\n^500" +
      "Dies ist <i>keine</i> Homepage.^500\n^500\n^500" +
      "<b class='warning'>Bitte verlassen Sie <b>sofort</b> diese Seite!</b>^3000"
    const s4 =
      "<span class='heading'>HINWEIS</span>^1000\n^500\n^500" +
      "Dies ist keine <i>sinnvolle</i> Homepage.^500\n^500\n^700" +
      "<b class='warning'>Bitte verlasse jetzt <b>wirklich</b> diese Seite!</b>^4000" +
      " <i>Bitte.</i>^4000" +
      "\n^400\n^700Bitte^400?^1200?^700?^6000"
    return [
      s2,
      s3,
      "<span class='heading'>HALLO^700!^2000?</span>",
      s4 +
        twemoji.parse("\n^2000\n^1000Ok.^1000 Kleiner Scherz.^1000 <span class='smiley'>😜</span>^4000\n^500\n^500") +
        "Aber hier steht <i>echt</i> nichts sinnvolles!^4000" +
        "\n^500\n^500\n^500Du glaubst das einfach nicht.^900 Oder?^4000" +
        "\n^1000\n^2000\nAber wart's nur ab.^5000 Hier kommt <i>echt</i> nichts von Inhalt.^5000" +
        "\n^600\n^700Hat mich aber echt gefreut,^200 dass Du ^300so^800o^500o^700o^500 lange dabei geblieben bist^500!" +
        '\nLG <a href="https://peter.tandlers.de">Peter</a>',
    ]
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Code+Pro&display=swap");
//@import url("https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap");
//@import url("https://fonts.googleapis.com/css?family=Source+Serif+Pro&display=swap");

#app {
  font-family: "Source Code Pro", monospace;
  // font-family: "Roboto Slab", serif;
  //  font-family: "Source Serif Pro", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  margin: 20px;
}

.typing {
  white-space: pre-wrap;

  .heading {
    font-weight: bold;
    font-size: 250%;
    margin-bottom: 2em;
  }
  .warning {
    color: red;
    font-weight: bold;
    b {
      font-weight: bolder;
      font-style: italic;
    }
  }
  .smiley {
    font-size: 110%;
  }
}

.typed-element {
  display: inline !important;
}

img.emoji {
  height: 1em;
  width: 1em;
  margin: 0 0.05em 0 0.1em;
  vertical-align: -0.1em;
}
</style>
